module.exports = __webpack_public_path__ + "static/img/fullscreen-image_lets-get_600.45f5e55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/policy-manual-wizard/fullscreen-image_lets-get_600.png
// module id = yYxT
// module chunks = 0